import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { maintenanceService } from 'shared/services';
import { MaintenanceColumns } from '../maintenances';

export const ArchivedMaintenances = () => {
  const translationPrefix = 'pages.maintenance-archive';

  const { t } = useTranslation();

  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = MaintenanceColumns(null, 'archive');

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={maintenanceService}
        getMethod={maintenanceService.getClosed}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
};

export default ArchivedMaintenances;
